const getCtaQueryParams = (trim, transmission) => {
    var _a, _b, _c;
    return ({
        modelYear: trim.modelYear,
        modelKey: trim.modelKey,
        trimKey: trim.trimKey,
        transmissionKey: (_a = transmission === null || transmission === void 0 ? void 0 : transmission.transmissionKey) !== null && _a !== void 0 ? _a : '',
        exteriorColorKey: decodeURIComponent((_b = transmission === null || transmission === void 0 ? void 0 : transmission.exteriorColorKey) !== null && _b !== void 0 ? _b : ''),
        interiorColorKey: decodeURIComponent((_c = transmission === null || transmission === void 0 ? void 0 : transmission.interiorColorKey) !== null && _c !== void 0 ? _c : ''),
        inventoryStatus: trim.inventoryStatus,
    });
};
export default getCtaQueryParams;
